/**
 * Full-page moves the billing flow makes, behind one seam so tests can watch
 * them (jsdom's `window.location` cannot be stubbed).
 */

/** Hand the browser to the payment provider's hosted checkout. */
export function goToCheckout(url: string): void {
  window.location.assign(url);
}

/** Leave the billing-only page for the full shell, with a fresh page load. */
export function reloadIntoShell(): void {
  window.location.replace("/");
}
